import { useQuery } from '@tanstack/react-query'
import { taskProgressApi, type TaskProgressDetail, type TaskProgressSummary } from '../api/taskProgressApi'
import type { WorkProgressQuery } from '../constants/taskProgress.logic'

// 공종 상세창 시공 진행 요약·세부 조회(B-08·B-09). 상세창이 열릴 때마다 다시 읽는다(staleTime 0).

export const TASK_PROGRESS_KEY = 'task-progress'

/** 시공 진행 요약 — taskId 가 없으면 조회하지 않는다 */
export function useTaskProgressSummary(taskId: number | null): WorkProgressQuery & { reload(): void } {
  const q = useQuery<TaskProgressSummary>({
    queryKey: [TASK_PROGRESS_KEY, 'summary', taskId],
    queryFn: ({ signal }) => taskProgressApi.getSummary(taskId as number, signal),
    enabled: taskId != null,
    staleTime: 0,
    refetchOnMount: 'always',
    retry: false,
  })
  const reload = () => { void q.refetch() }
  if (q.isError) return { status: 'error', reload }
  if (q.data) return { status: 'ready', summary: q.data, reload }
  return { status: 'loading', reload }
}

/** 시공 진행 세부 — 팝업이 열려 있을 때만 조회 */
export function useTaskProgressDetail(taskId: number | null, enabled: boolean) {
  return useQuery<TaskProgressDetail>({
    queryKey: [TASK_PROGRESS_KEY, 'detail', taskId],
    queryFn: ({ signal }) => taskProgressApi.getDetail(taskId as number, signal),
    enabled: enabled && taskId != null,
    staleTime: 0,
    retry: false,
  })
}
